import { push } from 'react-router-redux';
import { AppThunkAction } from './index';

export default function goToProfile(): AppThunkAction {
  return dispatch => {
    dispatch(push('/account/profile'));
  };
}
